import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonAnonymous12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPersonAnonymous12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.389 5.579a2.5 2.5 0 0 1-.952.382v.601a.437.437 0 1 1-.875 0V5.438A.44.44 0 0 1 6 5h.11a1.504 1.504 0 1 0-1.614-1.5H3.5a2.5 2.5 0 1 1 3.889 2.079M9 9a3 3 0 0 0-1.274-2.454c.302-.172.576-.387.813-.637A4 4 0 0 1 10 9v2H2V9c0-1.245.569-2.357 1.46-3.091.238.25.512.465.814.637A3 3 0 0 0 3 9v1h6zm-3 .25a.437.437 0 0 0 .438-.437v-.626a.438.438 0 0 0-.875 0v.626c0 .241.195.437.437.437"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonAnonymous12);
